export default "dist/67bf827e3f0dfb0755dac64e37614840.woff";